/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';

const state = {
  parking: {},
  error: null,
  coordinates: [],
  occupancy: {},
  receiptUrl: '',
};

const getters = {
  parking: state => state.parking,
  coordinates: state => state.coordinates,
  error: state => state.error,
  occupancy: state => state.occupancy,
  receiptUrl: state => state.receiptUrl,
};

const actions = {
  fetch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/parkings/${payload.id}`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  save({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    let request = '';
    if (payload.parking.id) {
      request = Vue.http.put(`${process.env.BACKEND_API_URL}api/${path}/parkings/${payload.parking.id}`, payload.parking);
    } else {
      request = Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/parkings`, payload.parking);
    }
    return request
      .then((response) => {
        commit(mTypes.DATA_STORED, response);
      })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveBatch({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/parkings/batch`, payload.parking)
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  confirm({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/parkings/${payload.id}/confirm`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      }).catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  stop({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.post(`${process.env.BACKEND_API_URL}api/${path}/parkings/${payload.id}/stop`, payload.endTime)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
  delete({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/parkings/${payload.id}`)
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  deleteBulk({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/parkings/bulk`, { params: { ids: payload.ids, _method: 'DELETE' } })
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  delete_price({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/parkings/${payload.id}/price`)
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  get_price({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.get(`${process.env.BACKEND_API_URL}api/${path}/parkings/price`, { params: payload.parking });
  },
  deleteConference({ commit }, payload) {
    const path = `${payload.user.data.selectedRole.role}s/${payload.user.data.selectedRole.id}`;
    return Vue.http.delete(`${process.env.BACKEND_API_URL}api/${path}/parkings/conference/${payload.id}`)
      .then(() => { })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  saveConference({ commit }, payload) {
    const request = Vue.http.post(`${process.env.BACKEND_API_URL}api/parkings/conference`, payload);
    return request
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  fetchOccupancy({ commit }, payload) {
    const { month, productID } = payload;
    const selectedMonth = typeof month === 'number' ? month : new Date().getMonth();
    const formattedMonthToAPI = () => {
      if (selectedMonth < 0) {
        return 12;
      }

      if (selectedMonth === 12) {
        return 1;
      }
      return selectedMonth + 1;
    };

    const path = `api/products/${productID}/occupancy?month=${formattedMonthToAPI()}`;
    const request = Vue.http.get(`${process.env.BACKEND_API_URL}${path}`);

    return request.then((response) => {
      commit(mTypes.FETCHED_OCCUPANCY, response);
    })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
  downloadReceipt({ commit }, payload) {
    const path = `api/v3/easy-parking/${payload.parkingID}/receipt`;
    const request = Vue.http.get(`${process.env.BACKEND_API_URL}${path}`);

    return request.then((response) => {
      commit(mTypes.SET_RECEIPT_URL, response);
    })
      .catch((response) => {
        commit(mTypes.DATA_ERROR, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, parking) {
    state.parking = parking.data;
    state.error = null;
    state.coordinates = [];
    if (state.parking.product) {
      state.parking.product.zones.forEach(el => (el.coordinates
        ? state.coordinates.push(el.coordinates)
        : true));
    }
  },
  [mTypes.FETCHED_OCCUPANCY](state, occupancy) {
    state.occupancy = occupancy.body.data;
  },
  [mTypes.SET_RECEIPT_URL](state, response) {
    state.receiptUrl = response.body.url;
  },
  [mTypes.CLEAR_STATE](state) {
    state.parking = {};
    state.coordinates = [];
    state.occupancy = {};
  },
  [mTypes.DATA_STORED](state, parking) {
    state.parking = parking.data;
    state.coordinates = [];
  },
  [mTypes.DATA_ERROR](state, error) {
    state.error = error === null ? error : error.data.message;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/parkings/parking.js